<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5" >
              <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Service  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/mservicetechnician/index"> Manage Service Technician   </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Create Service Technician </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div class="container-fluid">
                    <div class="card custom_bdr_rds">
                        <div style="background-color: #f2f3f4; " class="card-body custom_bdr_rds">


                    <form @submit.prevent="SaveProduct()" >

<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Technician Name </label>
            <input  v-model="all_data.name"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Area </label>
            <input  v-model="all_data.area"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Type </label>
            <v-select label="label"  v-model="all_data.type" :options="types" ></v-select>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Contact No</label>
          
            <input  v-model="all_data.contact_no"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
</div>

<div class="row">
 
  
 <div class="col-md-3">
   <div class="form-group required">
           <label class="custom-label" style="font-size: small;">Qualifications </label>
           <v-select label="modelname"  v-model="all_data.model_name" :options="models"  multiple></v-select>
   </div>
 </div>


 </div>

















   

    <div style="border-bottom: 0px; padding-top: 0px;background-color: #f2f3f4;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  " >
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadData()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
           
        total:0,
        selectedOption: null, // Store the selected option
       

        brands:[],
        models:[],
        vehicles:[],
        Locations:[],
        all_data:{},
       
      
        types: [
            { label: 'Spare Parts', value: '1' },
            { label: 'Batteries', value: '3' },
            { label: 'Vehicle', value: '2' },
            { label: 'Service', value: '4' },
            // Add more options as needed
        ],
        
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    

       

    async SaveProduct() {
       
      console.log(this.all_data);
   
    console.log("amila");
       try {
         const { data} = await  axios.post('/mservicetechnician/create',{userid:this.userid,all_data:this.all_data},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/mservicetechnician/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },


     async loadData() {
       
     
        try {
          const { data} = await  axios.get('/mservicetechnician/loadqulification',{
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);

           this.models = data.models;
        
           
            
          
        } catch (error) {
          console.log(error.response);
        }
      },
       

     

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    